import moment from 'moment';
import 'moment/locale/th';
import { toBuddhistYear } from '../../../../../util/util';

export const htmlToStringTh = (data, fileName, imageUrl) => {
    moment.locale('th');
    return `
<html>
  <head>
    <meta charset="UTF-8" />
    <title>Document</title>
    <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
    <script src="https://evidenceprime.github.io/html-docx-js/test/vendor/FileSaver.js"></script>
    <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
  </head>
  <body>
  <div style="word-break: break-word;">
    <center>
    ${imageUrl ? `<img src="${imageUrl}" width="100" height="100">` : `<div />`}
      <h3>${data?.titleTh}</h3>
    </center>
    <h4>${data?.templateNameTh}</h4>
    ${data?.templateDesignIdentity
        ?.map(
            (item) =>
                `<p>${item?.labelNameTh}____________________________________________</p>`
        )
        .join(' ')}
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${data?.firstParagraphTh}
    </p>
    <div>
    ${data?.consentForms
        .map((consent) =>
            consent?.noteId
                ? `${consent?.titleTh}`
                : `
    <div style="margin-bottom: 20px">
    <strong>${consent?.consentNameTh}</strong>
    <p>
    ${consent?.purposeTh}
    </p>
    ${
        !consent?.isConsented
            ? `<p>
      <span><span>◽</span> ยินยอม</span>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span><span>◽</span> ไม่ยินยอม</span>
    </p>`
            : `<p><span><span>◽</span> รับทราบ</span></p>`
    }
    </div> `
        )
        .join(' ')}
      </div>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${data?.certificationTh}
    </p>
    <p><strong>ช่องทางการติดต่อ</strong></p>
    <p>
    ${data?.contactChannelTh}
    </p>
    <p>เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อ ${toBuddhistYear(
        moment(data?.effectiveDate),
        'LL'
    )}</p>
    <div style="text-align: right; padding-top: 3rem">
      <p>ลายมือชื่อ: __________________________</p>
      <p>ชื่อ-นามสกุล: ________________________</p>
      <p>วันที่: ____________________________</p>
    </div></div>
    <script type="text/javascript">
    $(document).ready(function() {
      let allElements = $('*');
      let converted = htmlDocx.asBlob(allElements.html());
      saveAs(converted, '${fileName}');
      setTimeout(()=> window.close(), 100)
    });
    </script>
  </body>
</html>
`;
};

export const htmlToStringEn = (data, fileName, imageUrl) => {
    moment.locale('en');
    return `
<html>
  <head>
    <meta charset="UTF-8" />
    <title>Document</title>
    <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
    <script src="https://evidenceprime.github.io/html-docx-js/test/vendor/FileSaver.js"></script>
    <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
  </head>
  <body>
  <div style="word-break: break-word;">
    <center>
    ${imageUrl ? `<img src="${imageUrl}" width="100" height="100">` : `<div />`}
      <h3>${data?.titleEn}</h3>
    </center>
    <h4>${data?.templateNameEn}</h4>
    ${data?.templateDesignIdentity
        ?.map(
            (item) =>
                `<p>${item?.labelNameEn}____________________________________________</p>`
        )
        .join(' ')}
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${data?.firstParagraphEn}
    </p>
    <div>
    ${data?.consentForms
        .map((consent) =>
            consent?.noteId
                ? `${consent?.titleEn}`
                : `
    <div style="margin-bottom: 20px">
    <strong>${consent?.consentNameEn}</strong>
    <p>
    ${consent?.purposeEn}
    </p>
    ${
        !consent?.isConsented
            ? `<p>
      <span><span>◽</span> I agree</span>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span><span>◽</span> Decline</span>
    </p>`
            : `<p><span><span>◽</span> Acknowledge</span></p>`
    }
    </div>
    `
        )
        .join(' ')}</div>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${data?.certificationEn}
    </p>
    <p><strong>Contact channel</strong></p>
    <p>
    ${data?.contactChannelEn}
    </p>
    <p>This document was last updated on ${moment(data?.effectiveDate).format(
        'LL'
    )}</p>
    <div style="text-align: right; padding-top: 3rem">
      <p>Signature: ____________________________</p>
      <p>Name: ____________________________</p>
      <p>Date: ____________________________</p>
  </div></div>
  <script type="text/javascript">
  $(document).ready(function() {
    let allElements = $('*');
    let converted = htmlDocx.asBlob(allElements.html());
    saveAs(converted, '${fileName}');
    setTimeout(()=> window.close(), 100)
  });
  </script>
  </body>
</html>
    `;
};

export const htmlTermToStringTh = (data, fileName, imageUrl) => {
    moment.locale('th');

    return `
<html>
  <head>
    <meta charset="UTF-8" />
    <title>Document</title>
    <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
    <script src="https://evidenceprime.github.io/html-docx-js/test/vendor/FileSaver.js"></script>
    <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
  </head>
  <body>
  <div style="word-break: break-word;">
    <center>
    ${imageUrl ? `<img src="${imageUrl}" width="100" height="100">` : `<div />`}
      <h3>${data?.titleTh}</h3>
    </center>
    ${data?.templateNameTh}
    ${data?.purpose}
    <p><span><span>◽</span> รับทราบ</span></p><br/>
    <p>เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อ ${toBuddhistYear(
        moment(data?.effectiveDate),
        'LL'
    )}</p><br/>
    <div style="text-align: right; padding-top: 3rem">
      <p>ลายมือชื่อ: __________________________</p>
      <p>ชื่อ-นามสกุล: ________________________</p>
      <p>วันที่: ____________________________</p>
    </div></div>
    <script type="text/javascript">
    $(document).ready(function() {
      let allElements = $('*');
      let converted = htmlDocx.asBlob(allElements.html());
      saveAs(converted, '${fileName}');
      setTimeout(()=> window.close(), 100)
    });
    </script>
  </body>
</html>
`;
};

export const htmlTermToStringEn = (data, fileName, imageUrl) => {
    moment.locale('en');

    return `
<html>
<head>
  <meta charset="UTF-8" />
  <title>Document</title>
  <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
  <script src="https://evidenceprime.github.io/html-docx-js/test/vendor/FileSaver.js"></script>
  <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
</head>
<body>
<div style="word-break: break-word;">
  <center>
 ${imageUrl ? `<img src="${imageUrl}" width="100" height="100">` : `<div />`}
    <h3>${data?.titleEn}</h3>
  </center>
  ${data?.templateNameEn}
  ${data?.purpose}
  <p><span><span>◽</span> Acknowledge</span></p><br/>
  <p>This document was last updated on ${moment(data?.effectiveDate).format(
      'LL'
  )}</p><br/>
  <div style="text-align: right; padding-top: 3rem">
    <p>Signature: ____________________________</p>
    <p>Name: ____________________________</p>
    <p>Date: ____________________________</p>
  </div></div>
  <script type="text/javascript">
  $(document).ready(function() {
    let allElements = $('*');
    let converted = htmlDocx.asBlob(allElements.html());
    saveAs(converted, '${fileName}');
    setTimeout(()=> window.close(), 100)
  });
  </script>
</body>
</html>
`;
};
